export const ENV_TYPE: 'dev' | 'test' | 'stg' | 'prod' = 'dev';
